import HomeUser from './HomeUser';
import { Subject } from 'rxjs/Subject';
import { updated$, get, update } from './crud';
import { isLoggedIn, logOut, loggedOut$, logIn, getHomeUserAccessToken } from './loginSession';
import setFromFirebaseToken from './setFromFirebaseToken';
import { deleteToken, setToken, getToken } from './tokenManager';

type Identity = {
  setFromFirebaseToken: (token: string) => Promise<void>;
  updated$: Subject<HomeUser>;
  get: () => HomeUser;
  update: (HomeUser) => void;
  isLoggedIn: () => boolean;
  logOut: () => void;
  getToken: (name: string) => string;
  setToken: (name: string, token: string) => void;
  deleteToken: (name: string) => void;
  loggedOut$: Subject<HomeUser>;
  logIn: (token: string, mdn?: string) => Promise<void>;
  getHomeUserAccessToken: () => string | undefined;
};

const identity: Identity = {
  setFromFirebaseToken,
  updated$,
  get,
  update,
  isLoggedIn,
  logOut,
  setToken,
  getToken,
  deleteToken,
  loggedOut$,
  logIn,
  getHomeUserAccessToken,
};

export default identity;
export { default as HomeUser } from './HomeUser';
export { default as enrichAnalyticsWithUser } from './enrichAnalyticsWithUser';



// WEBPACK FOOTER //
// ./packages/platform-core/identity/index.ts